import { Button } from "@mui/material";
import Autorenew from "@mui/icons-material/Autorenew";
import { useRegenerateLicenseInvoiceMutation } from "Api/Mutations/Licenses/useRegenerateLicenseInvoiceMutation";
import { useIsCurrentUserAdmin } from "Hooks/useIsCurrentUserAdmin";
import { Resources, useResource } from "Translations/Resources";

const CONTROLS_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Licenses.Form.Controls;

type Props = {
  licensePublicID: string;
  invoiceEmailSent: boolean;
};

export const RegenerateInvoiceButton = ({
  licensePublicID,
  invoiceEmailSent,
}: Props) => {
  const { t } = useResource();
  const isAdmin = useIsCurrentUserAdmin();

  const { mutate: regenerateInvoice, isPending } =
    useRegenerateLicenseInvoiceMutation();

  // Only admins can regenerate, and only once an invoice has actually been issued.
  if (!isAdmin || !invoiceEmailSent) {
    return null;
  }

  return (
    <Button
      variant="outlined"
      startIcon={<Autorenew />}
      onClick={() => regenerateInvoice({ licensePublicID })}
      disabled={isPending}
      sx={{ minWidth: "160px", height: "44px" }}
    >
      {isPending
        ? t(CONTROLS_RESOURCES.RegeneratingInvoice)
        : t(CONTROLS_RESOURCES.RegenerateInvoice)}
    </Button>
  );
};
